import { createAction } from '@reduxjs/toolkit'

export const palkkausPageInitialized = createAction<{ iframeUrl: string; authToken: string }>('palkkausPageInitialized')
